import React from "react";
import { Route} from "react-router-dom";
import Footer from "../layouts/UserNav/Footer";
import AffiliateNav from "../layouts/AffiliateNav/AffiliateNav";

const AffiliateRoute = ({ component: Component, ...rest }) => {
  return (
    <>
      <AffiliateNav />
      <Route {...rest} render={(props) => <Component {...props} />} />
      <Footer />
    </>
  );
};

export default AffiliateRoute;
